<template>
  <section class="content">
    <div class="row">
      <div class="col-md-12">
        <div class="box box-primary">
          <div class="box-header with-border">
            <h3 class="box-title">
              <b>Relatório de Faturamento</b>
            </h3>
          </div>
          <div class="box-body">
            <div class="row">
              <div class="col-sm-2">
                <div class="form-group">
                  <label for="mes">Mês</label>
                  <select class="form-control" v-model="dados.mes">
                    <option value = '01'>Janeiro</option>
                    <option value = '02'>Fevereiro</option>
                    <option value = '03'>Março</option>
                    <option value = '04'>Abril</option>
                    <option value = '05'>Maio</option>
                    <option value = '06'>Junho</option>
                    <option value = '07'>Julho</option>
                    <option value = '08'>Agosto</option>
                    <option value = '09'>Setembro</option>
                    <option value = '10'>Outubro</option>
                    <option value = '11'>Novembro</option>
                    <option value = '12'>Dezembro</option>
                  </select>
                </div>
              </div>
              <div class="col-sm-2">
                <div class="form-group">
                  <label for="ano">Ano</label>
                  <select class="form-control" v-model="dados.ano">
                    <option value = '2019'>2019</option>
                    <option value = '2020'>2020</option>
                    <option value = '2021'>2021</option>
										<option value = '2022'>2022</option>
										<option value = '2023'>2023</option>
										<option value = '2024'>2024</option>
										<option value = '2025'>2025</option>
                    <option value = '2026'>2026</option>
                  </select>
                </div>
              </div>
              <div class="col-sm-2">
                  <br/>
                  <button @click="gerarRelatorio" style="margin-top: 0.3em;" class="form-group btn btn-primary"><i class="fa fa-print"></i> Gerar</button>
              </div>
            </div>
            <div v-if="showRelatorio" class="row" style="margin-top:15px">
              <div class="col-sm-12 table-responsive">
                <table
                  aria-describedby="example1_info"
                  role="grid"
                  id="example1"
                  class="table table-bordered table-striped"
                >
                  <thead>
                    <tr role="row">
                      <th style="width: 15%">Loja</th>
                      <th style="width: 11%">Repasse Bruto</th>
                      <th style="width: 11%">Recebido Estab</th>
                      <th style="width: 11%">Serviços Premium</th>
                      <th style="width: 11%">Repasse Líquido</th>
                      <th style="width: 11%">Recebido Premium</th>
                      <th style="width: 11%">Receita</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr class="even" role="row" v-for="item in apiData.data.itens" :key="item.razao">
                      <td>{{ item.razao }}</td>
                      <td>{{ item.total_boletos | numberFormat(2, ',', '.') }}</td>
                      <td>{{ (item.recebido_estabelecimento ? item.recebido_estabelecimento:'0') | numberFormat(2, ',', '.') }}</td>
                      <td>{{ (item.servicos_premium ? item.servicos_premium:'0') | numberFormat(2, ',', '.') }}</td>
                      <td>{{ (item.repasse_liquido ? item.repasse_liquido:'0') | numberFormat(2, ',', '.') }}</td>
                      <td>{{ (item.recebido_premium ? item.recebido_premium:'0') | numberFormat(2, ',', '.') }}</td>
                      <td :class="item.recebido_premium - item.repasse_liquido > 0 ? 'green':'red'">{{ ((item.recebido_premium - item.repasse_liquido) ? item.recebido_premium - item.repasse_liquido:'0') | numberFormat(2, ',', '.') }}</td>
                    </tr>
                  </tbody>
                  <tfoot>
                      <tr class="even">
                       <td style="font-weight:bold">Subtotal</td>
                      <td style="font-weight:bold">{{ apiData.data.total_boletos | numberFormat(2, ',', '.') }}</td>
                      <td style="font-weight:bold">{{ (apiData.data.total_recebido_estabelecimento ? apiData.data.total_recebido_estabelecimento:'0') | numberFormat(2, ',', '.') }}</td>
                      <td style="font-weight:bold">{{ (apiData.data.total_servicos_premium ? apiData.data.total_servicos_premium:'0') | numberFormat(2, ',', '.') }}</td>
                      <td style="font-weight:bold">{{ (apiData.data.total_repasse_liquido ? apiData.data.total_repasse_liquido:'0') | numberFormat(2, ',', '.') }}</td>
                      <td style="font-weight:bold">{{ (apiData.data.total_recebido_premium ? apiData.data.total_recebido_premium:'0') | numberFormat(2, ',', '.') }}</td>
                      <td :class="apiData.data.total_recebido_premium - apiData.data.total_repasse_liquido > 0 ? 'green':'red'" style="font-weight:bold">{{ ((apiData.data.total_recebido_premium - apiData.data.total_repasse_liquido) ? apiData.data.total_recebido_premium - apiData.data.total_repasse_liquido:'0') | numberFormat(2, ',', '.') }}</td>
                      </tr>
                  </tfoot>
                </table>
              </div>
            </div>
          </div>
          <!-- /.box-body -->
        </div>
        <!-- /.box -->
      </div>
      <!-- /.col-md-12 -->
    </div>
    <!-- /.row -->
  </section>
</template>
<script>
import axios from "axios"; // Cliente para requisição http
import vSelect from "vue-select";

export default {
  data: () => ({
    showRelatorio: false,
    dados: {
      mes: '01',
      ano: 2022,
    },
    apiData: {
        data: []
    }
  }),
  mounted() {

  },

  methods: {
    gerarRelatorio() {
      let config = this.$store.getters.getHeaderAuth;
				config.params = this.dados;
        axios
        .get(
          `${this.$store.state.serverURI}/api/relatorio/getFaturamento`,
          config
        )
        .then(response => {
          console.log(response.data);
          this.apiData = response;
         });
        this.showRelatorio = true;
    },
  },
  watch: {

  },

  components: {
      vSelect
  }
};
</script>
<style>
td {
  text-transform: uppercase;
}

.red {
  color: red
}

.green {
  color: green
}

</style>



// WEBPACK FOOTER //
// index.vue?7d5a16b1